import { render, staticRenderFns } from "./pageination.vue?vue&type=template&id=b3dff1ea&scoped=true&"
import script from "./pageination.vue?vue&type=script&lang=js&"
export * from "./pageination.vue?vue&type=script&lang=js&"
import style0 from "./pageination.vue?vue&type=style&index=0&id=b3dff1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dff1ea",
  null
  
)

export default component.exports